import React from 'react';
import {
	Checkbox,
	FormGroup,
	Typography,
	FormControlLabel,
} from '@mui/material';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import content from './content';
import { addItemsStyles } from './styles';
import {
	updateAddItemCheckBox,
	updateAddProductCheckBox,
} from '../../../redux/actions/createRuleActions';

const CheckBoxGroup = ({ type }) => {
	const c = content[type]?.add;
	const dispatch = useDispatch();
	const { locationCheckBox, productCheckBox } = useSelector(
		(state) => state.createRuleReducer
	);
	const { alertForAggregated, alertForIndividual } = locationCheckBox;
	const { alertForProductAggregated, alertForProductIndividual } =
		productCheckBox;
	const isStore = c?.item === 'Store';
	const onCheckBoxClickHandler = (identifier, isChecked) => {
		if (isStore) {
			let aggregated = alertForAggregated;
			let individual = alertForIndividual;
			if (identifier === 'aggregated') {
				aggregated = !!isChecked;
				individual = !isChecked;
			}
			if (identifier === 'individual') {
				individual = !!isChecked;
				aggregated = !isChecked;
			}
			const storeCheckedOption = {
				alertForAggregated: aggregated,
				alertForIndividual: individual,
			};
			dispatch(updateAddItemCheckBox(storeCheckedOption));
		} else {
			let aggregated = alertForProductAggregated;
			let individual = alertForProductIndividual;
			if (identifier === 'aggregated') {
				aggregated = !!isChecked;
				individual = !isChecked;
			}
			if (identifier === 'individual') {
				individual = !!isChecked;
				aggregated = !isChecked;
			}
			const productCheckedOption = {
				alertForProductAggregated: aggregated,
				alertForProductIndividual: individual,
			};
			dispatch(updateAddProductCheckBox(productCheckedOption));
		}
	};

	return (
		<FormGroup style={addItemsStyles.checkBoxForm}>
			<FormControlLabel
				control={
					<Checkbox
						checked={isStore ? alertForAggregated : alertForProductAggregated}
						onChange={(e) =>
							onCheckBoxClickHandler('aggregated', e.target.checked)
						}
						sx={{ marginLeft: '10px !important' }}
						style={addItemsStyles.checkBox}
					/>
				}
				label={
					<Typography variant="p" style={addItemsStyles.checkBoxText}>
						{c['checkBoxAggregated']}
					</Typography>
				}
			/>
			<FormControlLabel
				control={
					<Checkbox
						checked={isStore ? alertForIndividual : alertForProductIndividual}
						onChange={(e) =>
							onCheckBoxClickHandler('individual', e.target.checked)
						}
						style={addItemsStyles.checkBox}
					/>
				}
				label={
					<Typography variant="p" style={addItemsStyles.checkBoxText}>
						{c['checkBoxIndividual']}
					</Typography>
				}
			/>
		</FormGroup>
	);
};

CheckBoxGroup.propTypes = {
	type: PropTypes.oneOf([
		'store',
		'item',
		'category',
		'department',
		'brand',
		'upc',
		'subcategory',
	]).isRequired,
};

export default CheckBoxGroup;
